import React from 'react';

const IconMedium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-medium">
    <title>Medium</title>
    <rect x="3" y="3" width="18" height="18" rx="4" />
    <path d="M7.5 16V8l3 5 3-5v8" />
    <path d="M18 15.25a2.25 2.25 0 1 1 0-4.5h-2.25v4.5H18z" />
  </svg>
);

export default IconMedium;
